
    import { loadModule, unloadModule } from './module-loader.js';
    
    let currentModule = null;
    
    window.navigateTo = async function(screenId, addToHistory = true) {
      // Limpiar módulo anterior si existe
      if (currentModule && currentModule !== 'home') {
        unloadModule(currentModule);
      }
      
      // Ocultar todas las pantallas
      document.querySelectorAll('.screen').forEach(s => s.classList.remove('active'));
      
      // Mostrar la pantalla seleccionada
      const screen = document.getElementById(screenId);
      if (screen) {
        screen.classList.add('active');
        
        // Si no es home, cargar el módulo
        if (screenId !== 'home') {
          const container = document.getElementById(`${screenId}-container`);
          if (container) {
            await loadModule(screenId, container);
            currentModule = screenId;
          }
        } else {
          currentModule = 'home';
        }
        
        // Añadir al historial del navegador
        if (addToHistory) {
          history.pushState({ screen: screenId }, '', `#${screenId}`);
        }
      }
    };
    
    // Manejar el botón atrás del navegador
    window.addEventListener('popstate', (event) => {
      if (event.state && event.state.screen) {
        navigateTo(event.state.screen, false);
      } else {
        navigateTo('home', false);
      }
    });
    
    // Establecer estado inicial
    history.replaceState({ screen: 'home' }, '', '#home');
  